<template>
  <footer class="main-footer">
    <div class="main-footer-container">
      <div class="md-layout">
        <div centered v-html="links" class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-large-size-80 md-xlarge-size-70 page-container">
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
  import { mapState } from 'vuex'
  import { storeUrl } from '../mixins/store'
  // import { apiServer } from '../config'

  export default {
    name: 'MainFooter',
    data: () => ({
      links: ''
    }),
    computed: {
      ...mapState({
        store: 'store'
      })
    },
    async mounted() {
      const url = storeUrl(this.store)
     // //window.console.log(url)
      if (url && url.length > 0) {
        const r = await this.$http.request({ url: `/home/getfooter`, method: 'get' }).catch(() => { })
        if (r && r.data) {
          let html = r.data
          html = html.replace(/document.write\('\s'\);/gi, '')
          html = html.replace(/document.write\('/gi, '')
          html = html.replace(/'\);/gi, '')
          html = html.replace(/src="\/content2/gi, 'src="' + url + '/content2/')
          html = html.replace(/href="\//gi, 'href="' + url + '/')
          this.links = html
        }
      }
    }
  }
</script>

<style>

  #global-footer a {
    text-decoration: none;
    color: #999;
    font-family: akrobat, sans-serif;
  }

    #global-footer a:hover {
      text-decoration: none;
      color: rgb(255, 255, 255);
    }

  #global-footer {
    background-color: #21384d;
    color: #999;
    padding: 40px 0;
    width: 100%;
  }

    #global-footer .container {
      clear: both;
      display: block;
      margin: 0 auto;
      width: 100%;
    }

    #global-footer .row .footer-section:last-child {
      display: none;
    }

    #global-footer ul,
    #global-footer ul li,
    #sitemap ul,
    #sitemap ul li {
      list-style: none;
      margin: 0;
      padding: 0;
    }

    #global-footer ul,
    #sitemap ul {
      margin-top: 10px;
      list-style: none;
      list-style-position: outside;
      padding-left: 0;
    }

      #global-footer ul.last,
      #sitemap ul.last {
        margin-right: 0;
      }

      #global-footer ul li,
      #global-footer label {
        padding: 2px 0;
        font-size: 14px;
        line-height: 1.35em;
        margin-bottom: 0;
      }

        #global-footer ul li ul li ul {
          margin-top: 0px;
        }

    #global-footer input,
    #global-footer label {
      display: none;
    }

    #global-footer .title {
      font-family: akrobat, sans-serif;
      font-weight: 600;
      color: #fff;
      white-space: nowrap;
      text-transform: uppercase;
      letter-spacing: 1px;
      position: relative;
      margin: 0;
      -webkit-transition: .3s;
      -o-transition: .3s;
      transition: .3s;
    }

      #global-footer .title :before {
        display: none;
        position: absolute;
        top: 0px;
        right: 5px;
        color: #999;
        line-height: 2;
        font-size: 120%;
      }

    #global-footer .footer-section {
      width: 24%;
      float: left;
    }

    #global-footer .social-icons-wrapper,
    #global-footer .footer-social {
      display: none;
    }

    #global-footer .footer-copyright {
      display: block;
      width: 100%;
      clear: both;
      text-align: center;
      padding-top: 30px;
    }

  @media (max-width:959px) {
    #global-footer .footer-section {
      display: none;
    }
  }
</style>

<style lang="scss" scoped>
  @import "~vue-material/dist/theme/engine";

  .main-footer {
    padding: 20px 16px;
    position: static;
    background-color: #21384d;
  }

  div.main-footer-container {
    width: 100%;
  }
</style>